import React, { useState, useEffect } from 'react';
import HeaderNonSrp from '../header/headerNonSrp';
import SubHeader from '../header/subHeader';
import Footer from '../footer/footer';
import EditCard from './editCard';
import AccountLoader from '../manageAccount/accountLoader';
import Edit from '../edit/edit';
import { apiUrl } from '../common/constants';
import { GetRequest, getparamsString } from '../common/helper';
const GuestEditConfirm = () => {
    const params = new URLSearchParams(window.location.search);
    const pnr = params.get('pnr');
    const mobile = params.get('mobile');

    const [bookingData, setBookingData] = useState(false)
    const [loader, setLoader] = useState(false);
    useEffect(() => {
        getPnrDetail()
    }, [pnr])


    const getPnrDetail = () => {

        setLoader(true);
        if (pnr) {
            setLoader(true);
            const data = {
                PNR: pnr,
                mobile: mobile,
            };
            const url = apiUrl.bookingInfo + "?" + getparamsString(data);
            GetRequest(url)
                .then((res) => {
                    setLoader(false);
                    // console.log(res)
                    if (res.Status && !res.Error) {
                        let bookingInfo = res.BookingInfo.APIGetBookingDetailsResult[0];
                        setBookingData(
                            bookingInfo
                        );
                    } else {
                        if (res.Error) {
                            setErrorMsg(res.Error)
                        }
                    }
                })
                .catch((err) => {
                    setLoader(false);
                    console.log(err);
                });
        }
    }
    // console.log("bookingData", bookingData);
    return (
        <div style={{ backgound: '#ccc' }}>
            {loader && <AccountLoader />}
            <HeaderNonSrp />
            <SubHeader />
            <div style={{ padding: '20px 6%' }} className='guest--edit--wrapper'>
                {bookingData && bookingData.RouteCode
                    &&
                    <>
                        <EditCard val={bookingData} />
                        <Edit
                            routeID={bookingData.RouteCode}
                            BookingRefNo={bookingData.BookingRefNo}
                            PNR={bookingData.PNR}
                            defPickup={{ id: bookingData.PickupID, name: bookingData.PickupName }}
                            defDropOff={{ id: bookingData.DropoffID, name: bookingData.DropoffName }}
                            cancel={() => { }}
                        />
                    </>
                }
            </div>
            <Footer />
        </div>
    )
}

export default GuestEditConfirm;